module.exports = __webpack_public_path__ + "static/media/user.40e7ca1e.svg";